import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Homepage from "./components/homepage/HomePage";
import Module1 from "./components/Module1/Module1";
import Module2 from "./components/Module2/Module2";
import Module3 from "./components/Module3/Module3";
import Module4 from "./components/Module4/Module4";
import Module5 from "./components/Module5/Module5";
import Module6 from "./components/Module6/Module6";
import StrengthsActivity from "./components/StrengthsPage/StrengthsActivity";
import Statistics from "./components/Statistics/Statistics";

function App() {
  return (
    <Router>
      <div className="App">
        <div>
          <Switch>
            <Route exact path="/" component={Homepage} />
            <Route exact path="/Module1" component={Module1} />
            <Route exact path="/Module2" component={Module2} />
            <Route exact path="/Module3" component={Module3} />
            <Route exact path="/Module4" component={Module4} />
            <Route exact path="/Module5" component={Module5} />
            <Route exact path="/Module6" component={Module6} />
            <Route
              exact
              path="/StrengthsActivity"
              component={StrengthsActivity}
            />
            <Route exact path="/Statistics" component={Statistics} />
          </Switch>
        </div>
      </div>
    </Router>
  );
}

export default App;
